import {
    NOTIFICATION_CATALOG,
    type NotificationTypeKey,
} from '@apps/web/lib/notification_catalog.generated';
import { type NotificationChannel } from '@apps/web/lib/notification_channel_features';

export {
    NOTIFICATION_TYPE_KEYS,
    type NotificationTypeKey,
    TOAST_NOTIFICATION_TYPE_KEYS,
    type ToastNotificationTypeKey,
} from '@apps/web/lib/notification_catalog.generated';

export type NotificationChannelPreferences = Partial<
    Record<NotificationChannel, boolean>
>;

/**
 * Whether a notification type can actually be delivered on a channel.
 *
 * The settings grid greys a checkbox instead of offering a toggle nothing
 * honors. The answer comes from the generated catalog so it can never
 * disagree with the backend defaults or the producers.
 */
export function isNotificationChannelSupportedForType(
    key: NotificationTypeKey,
    channel: NotificationChannel,
): boolean {
    return NOTIFICATION_CATALOG[key].supportedChannels.includes(channel);
}
